export default __webpack_public_path__ + "locales/ru/InfoPanel.json?hash=00b7e2fa6aca2753907ee429a0479ee6";